import { motion } from 'framer-motion';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const AboutPage = () => {
  const expertise = [
    { icon: 'ri-star-line', title: 'Astrolojik Danışmanlık', years: '15+ Yıl' },
    { icon: 'ri-heart-3-line', title: 'Spiritüel Rehberlik', years: '12+ Yıl' },
    { icon: 'ri-flashlight-line', title: 'Enerji & Şifa', years: '10+ Yıl' },
    { icon: 'ri-book-open-line', title: 'Eğitmenlik', years: '8+ Yıl' },
  ];

  const values = [
    {
      icon: 'ri-shield-check-line',
      title: 'Etik & Gizlilik',
      description: 'Tüm seanslarınız tamamen gizli tutulur ve etik değerlere bağlı kalınır.',
    },
    {
      icon: 'ri-user-heart-line',
      title: 'Kişiye Özel Yaklaşım',
      description: 'Her danışanın benzersiz ihtiyaçlarına göre özelleştirilmiş çözümler.',
    },
    {
      icon: 'ri-hand-heart-line',
      title: 'Profesyonel Destek',
      description: '15 yılı aşkın deneyim ve sürekli gelişim ile güvenilir rehberlik.',
    },
    {
      icon: 'ri-compass-3-line',
      title: 'Bütünsel Bakış',
      description: 'Beden, zihin ve ruh dengesini gözeten holistik yaklaşım.',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-b from-primary-dark to-primary-navy overflow-hidden">
        <div className="absolute inset-0 opacity-10" style={{
          backgroundImage: 'radial-gradient(circle, #D4AF37 1px, transparent 1px)',
          backgroundSize: '50px 50px'
        }}></div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center"
          >
            <div className="inline-block px-6 py-2 bg-gold/20 rounded-full mb-6">
              <span className="text-gold text-sm font-medium uppercase tracking-wider">Hakkımda</span>
            </div>
            <h1 className="font-serif text-5xl lg:text-7xl font-bold text-white mb-6">
              Deniz Erin
            </h1>
            <p className="text-xl text-text-light max-w-3xl mx-auto leading-relaxed">
              Astrolog Danışman, Uzman Spiritüel Danışman & Eğitmen, Şifa ve Enerji Uzmanı
            </p>
          </motion.div>
        </div>
      </section>

      {/* Biography Section */}
      <section className="py-24">
        <div className="max-w-6xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            {/* Image */}
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="relative"
            >
              <div className="relative rounded-3xl overflow-hidden shadow-2xl">
                <div className="w-full h-[600px]">
                  <img
                    src="https://static.readdy.ai/image/aaba9897d2facfbc7f1204630a4017ac/3c31d8cc85aa6d42e6dd42df917c9910.png"
                    alt="Deniz Erin"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-primary-dark/40 via-transparent to-transparent"></div>
              </div>
              <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-gold/20 rounded-full blur-3xl"></div>
            </motion.div>

            {/* Content */}
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <h2 className="font-serif text-4xl font-bold text-primary-dark mb-6">
                Yolculuğum
              </h2>
              <div className="space-y-4 text-text-medium leading-relaxed">
                <p>
                  15 yılı aşkın süredir astroloji, spiritüel danışmanlık ve enerji şifası alanlarında 
                  profesyonel olarak çalışıyorum. Yıldızların dilini konuşmak ve insanların içsel 
                  yolculuklarına rehberlik etmek, benim için bir tutku ve yaşam amacı.
                </p>
                <p>
                  Her bireyin benzersiz bir enerji ve potansiyele sahip olduğuna inanıyorum. 
                  Danışanlarımla çalışırken, onların kendi güçlerini keşfetmelerine ve hayatlarında 
                  anlamlı dönüşümler yaratmalarına yardımcı olmayı hedefliyorum.
                </p>
                <p>
                  Astrolojik danışmanlık, spiritüel rehberlik ve enerji şifa seanslarımda, 
                  etik değerlere bağlı kalarak, gizlilik ilkesini ön planda tutarak ve her danışana 
                  özel çözümler sunarak çalışıyorum.
                </p>
                <p>
                  Sürekli gelişim ve öğrenme felsefesiyle, uluslararası eğitimler ve sertifika 
                  programlarına katılmaya devam ediyorum. Amacım, size en güncel ve etkili 
                  yöntemlerle hizmet sunmak.
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Expertise Section */}
      <section className="py-24 bg-cream">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <h2 className="font-serif text-4xl lg:text-5xl font-bold text-primary-dark mb-4">
              Uzmanlık Alanlarım
            </h2>
            <p className="text-text-medium text-lg max-w-2xl mx-auto">
              Yılların deneyimi ve sürekli gelişimle kazanılan uzmanlıklar
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {expertise.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-white rounded-2xl p-8 text-center shadow-lg hover:shadow-2xl transition-all duration-300"
              >
                <div className="w-16 h-16 bg-gold/20 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className={`${item.icon} text-3xl text-gold`}></i>
                </div>
                <h3 className="font-serif text-xl font-bold text-primary-dark mb-2">
                  {item.title}
                </h3>
                <p className="text-gold font-semibold">{item.years}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <h2 className="font-serif text-4xl lg:text-5xl font-bold text-primary-dark mb-4">
              Çalışma Yaklaşımım
            </h2>
            <p className="text-text-medium text-lg max-w-2xl mx-auto">
              Güven, etik ve profesyonellik üzerine kurulu değerlerim
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {values.map((value, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="flex items-start space-x-6 p-8 bg-white rounded-2xl border border-gold/20 hover:border-gold/40 hover:shadow-xl transition-all duration-300"
              >
                <div className="w-14 h-14 bg-gold/20 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className={`${value.icon} text-2xl text-gold`}></i>
                </div>
                <div>
                  <h3 className="font-serif text-xl font-bold text-primary-dark mb-2">
                    {value.title}
                  </h3>
                  <p className="text-text-medium leading-relaxed">
                    {value.description}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-primary-dark">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="font-serif text-3xl lg:text-4xl font-bold text-white mb-6">
              Birlikte Çalışmaya Hazır mısınız?
            </h2>
            <p className="text-text-light text-lg mb-8">
              Kişisel dönüşüm yolculuğunuza bugün başlayın
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6">
              <a
                href="/randevu"
                className="px-8 py-4 bg-gold text-primary-dark font-semibold rounded-full hover:scale-105 hover:shadow-2xl hover:shadow-gold/50 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                Randevu Al
              </a>
              <a
                href="/iletisim"
                className="px-8 py-4 border-2 border-gold text-gold font-semibold rounded-full hover:bg-gold hover:text-primary-dark transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                İletişime Geç
              </a>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;